import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, Legend, ResponsiveContainer } from "recharts";
import type { ScoreRecord } from "@/types";

export function ScoreChart({ data }: { data: ScoreRecord[] }) {
  // weekly / monthly を別系列に分けて描画
  const series = data.map((r) => ({
    yyyymmdd: r.yyyymmdd,
    label: `${r.yyyymmdd.slice(0, 4)}-${r.yyyymmdd.slice(4, 6)}-${r.yyyymmdd.slice(6, 8)}`,
    weekly: r.score_type === "weekly" ? Number(r.total_score) : null,
    monthly: r.score_type === "monthly" ? Number(r.total_score) : null,
  }));

  return (
    <div className="w-full h-72">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={series} margin={{ top: 8, right: 16, left: 8, bottom: 24 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
          <XAxis dataKey="label" tick={{ fontSize: 11 }} angle={-30} textAnchor="end" height={50} />
          <YAxis domain={[0, 100]} tick={{ fontSize: 11 }} />
          <Tooltip />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <Line type="monotone" dataKey="weekly" stroke="#2563eb" name="週次" connectNulls />
          <Line type="monotone" dataKey="monthly" stroke="#16a34a" name="月次" connectNulls strokeDasharray="4 2" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
